import React from 'react';
import { Tabs, Input } from 'antd';
import './styles.scss';

type Props = {
  title: {
    en: string;
    ar: string;
    fr: string;
  };
  subtitle: {
    en: string;
    ar: string;
    fr: string;
  };
  onTitleChange: (lang: string, value: string) => void;
  onSubtitleChange: (lang: string, value: string) => void;
};

export default function CreativeLanguageTabs({
  title,
  subtitle,
  onTitleChange,
  onSubtitleChange
}: Props) {
  const items = [
    {
      key: 'en',
      label: 'English',
      children: (
        <div className="language-tab-content">
          <div className="input-group">
            <label>Title</label>
            <Input
              value={title.en}
              onChange={(e) => onTitleChange('en', e.target.value)}
              placeholder="Enter title in English"
            />
          </div>
          <div className="input-group">
            <label>Subtitle</label>
            <Input
              value={subtitle.en}
              onChange={(e) => onSubtitleChange('en', e.target.value)}
              placeholder="Enter subtitle in English"
            />
          </div>
        </div>
      )
    },
    {
      key: 'ar',
      label: 'Arabic',
      children: (
        <div className="language-tab-content">
          <div className="input-group">
            <label>Title</label>
            <Input
              value={title.ar}
              onChange={(e) => onTitleChange('ar', e.target.value)}
              placeholder="أدخل العنوان بالعربية"
              dir="rtl"
            />
          </div>
          <div className="input-group">
            <label>Subtitle</label>
            <Input
              value={subtitle.ar}
              onChange={(e) => onSubtitleChange('ar', e.target.value)}
              placeholder="أدخل العنوان الفرعي بالعربية"
              dir="rtl"
            />
          </div>
        </div>
      )
    },
    {
      key: 'fr',
      label: 'French',
      children: (
        <div className="language-tab-content">
          <div className="input-group">
            <label>Title</label>
            <Input
              value={title.fr}
              onChange={(e) => onTitleChange('fr', e.target.value)}
              placeholder="Enter title in French"
            />
          </div>
          <div className="input-group">
            <label>Subtitle</label>
            <Input
              value={subtitle.fr}
              onChange={(e) => onSubtitleChange('fr', e.target.value)}
              placeholder="Enter subtitle in French"
            />
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="creative-language-tabs">
      <Tabs items={items} />
    </div>
  );
}
